import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Shown on small viewports when the user taps "Demo" — the interactive demo is desktop-first.
 */
export default function HowItWorksDesktopOnlyModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <>
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 1000,
          background: 'rgba(17, 17, 17, 0.45)',
          border: 'none',
          cursor: 'pointer',
        }}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="how-it-works-desktop-title"
        style={{
          position: 'fixed',
          zIndex: 1001,
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'min(92vw, 400px)',
          background: 'var(--white, #fffcf9)',
          border: '1px solid var(--border, #e8e0d8)',
          borderRadius: 16,
          padding: '24px 22px 20px',
          boxShadow: '0 20px 48px rgba(17, 17, 17, 0.12)',
        }}
      >
        <h2
          id="how-it-works-desktop-title"
          className="serif"
          style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.5px', color: '#111', margin: '0 0 10px' }}
        >
          View the demo on desktop
        </h2>
        <p style={{ fontSize: 15, lineHeight: 1.75, color: '#7a6b63', margin: '0 0 20px' }}>
          The interactive product walkthrough is designed for a larger screen. When you’re on a laptop or tablet, open{' '}
          <strong>orivonai.com</strong> and tap <strong>Demo</strong> again to try the full experience.
        </p>
        <button
          type="button"
          className="btn-primary"
          style={{ width: '100%', padding: '12px 16px', fontSize: 15, cursor: 'pointer' }}
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </>,
    document.body
  );
}
